// extracted by mini-css-extract-plugin
export default {"default_style":"Markdown_default_style__kz3S-"};